import * as React from 'react';

const SvgYouTube = (props) => (
  <svg
    width={20}
    height={20}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.985 5.155a2.088 2.088 0 0 0-1.473-1.473C15.212 3.333 10 3.333 10 3.333s-5.212 0-6.512.349a2.088 2.088 0 0 0-1.473 1.473C1.667 6.455 1.667 10 1.667 10s0 3.545.348 4.845a2.088 2.088 0 0 0 1.473 1.473c1.3.349 6.512.349 6.512.349s5.212 0 6.512-.349a2.087 2.087 0 0 0 1.473-1.473c.348-1.3.348-4.845.348-4.845s0-3.545-.348-4.845Zm-9.652 7.732V7.113l5 2.887-5 2.887Z'
      fill='#fff'
    />
  </svg>
);

export default SvgYouTube;
